import React from 'react'

import { useMainQueryData } from './useMainQueryData'

export const useMainQueryBrandGroups = () => {
  const survey = useMainQueryData()

  return React.useMemo(() => survey?.brandGroups ?? [], [survey?.brandGroups])
}
